/* eslint-disable no-console */
const isDev = process.env.NODE_ENV !== 'production'

export const logger = isDev ? console.log
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  : () => {}

